import { SCOPING_SECTORS } from '@models/constants';
import {
  ScopingEquipmentTableItem,
  SectorEquipmentData,
  SectorEquipmentDataResp,
  SectorEquipmentResp,
  SectorEquipmentTypeResp,
} from '@models/interfaces';
import { OtherEquipmentSumData, SectorDataState } from '@models/types';

type ScopingSectorsAcc = {
  equipmentTypeNames: string[];
  scopingSectors: SectorDataState;
};

export const getOtherEquipmentInfo = (
  otherEquipments: ScopingEquipmentTableItem[],
): OtherEquipmentSumData =>
  otherEquipments?.reduce(
    (
      summary: OtherEquipmentSumData,
      curItem: ScopingEquipmentTableItem,
    ): OtherEquipmentSumData => ({
      otherEquipments: [
        ...summary.otherEquipments,
        {
          generatedId: curItem?.id,
          equipment: curItem?.equipment?.id,
          equipmentType: curItem?.equipment?.equipmentType?.id,
          manufacturer: curItem?.equipment?.manufacturer?.id,
          quantity: curItem?.quantity,
        },
      ],
      equipmentTypeNames: [
        ...summary.equipmentTypeNames,
        curItem?.equipment?.equipmentType?.name,
      ],
    }),
    { otherEquipments: [], equipmentTypeNames: [] },
  );

export const getScopingSectorsInfo = (
  scopingSectors: SectorEquipmentDataResp[],
): ScopingSectorsAcc =>
  scopingSectors?.reduce(
    (acc: ScopingSectorsAcc, sector: SectorEquipmentDataResp) => ({
      equipmentTypeNames: [
        ...acc.equipmentTypeNames,
        ...sector.sectorEquipmentTypes.map(
          (equipmentType: SectorEquipmentTypeResp) =>
            equipmentType.equipmentType.name,
        ),
      ],
      scopingSectors: {
        ...acc.scopingSectors,
        [sector.type]: sector.sectorEquipmentTypes
          .sort((a: SectorEquipmentTypeResp, b: SectorEquipmentTypeResp) =>
            a.equipmentType.name.localeCompare(b.equipmentType.name),
          )
          .map((equipmentType: SectorEquipmentTypeResp) => ({
            equipmentType: equipmentType.equipmentType.id,
            equipments: equipmentType.equipments.map(
              (equipment: SectorEquipmentResp) => ({
                ...equipment,
                equipment: equipment?.equipment?.id,
                manufacturer: equipment?.equipment?.manufacturer?.id,
              }),
            ),
          })),
      },
    }),
    {
      scopingSectors: SCOPING_SECTORS,
      equipmentTypeNames: [],
    },
  );

export const getScopingSectorsFromUpdateData = (
  sectors: SectorEquipmentData[],
): SectorDataState =>
  sectors?.length
    ? sectors.reduce(
        (acc: SectorDataState, curSector: SectorEquipmentData) => ({
          ...acc,
          [curSector.type]: curSector.sectorEquipmentTypes,
        }),
        SCOPING_SECTORS,
      )
    : SCOPING_SECTORS;
